import React from 'react';
import EditCourse from './edit';

const EditCoursePage = () => {
  return <EditCourse />;
};

export default EditCoursePage;
